// Конфигурация приложения
export const config = {
  api: {
    baseUrl: process.env.REACT_APP_API_URL || 'https://api.aibdm.cloud.technokratos.com/api',
    //baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:8080/api',
  },
  auth: {
    tokenKey: 'aibdm_auth_token', // Ключ для сохранения токена в localStorage
  },
} as const; 